var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('center', {
    staticClass: "logo-container"
  }, [_c('v-img', {
    attrs: {
      "src": _vm.logoImage,
      "max-height": "90px",
      "max-width": "240px",
      "contain": ""
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }